/**
 * Select wrapper that loads some status options
 * For when statuses may need to be retrieved from the server
 *
 * @format
 */

import React from 'react';
import SuperAgent from 'superagent';
import Select from './select';

class StatusSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            options: []
        };
    }

    //grab statuses on mount
    componentDidMount() {
        this.setState({
            loading: true
        });

        SuperAgent.get(this.props.endpoint)
            .set('Accept', 'application/json')
            .end((err, resp) => {
                if (resp && resp.body) {
                    this.setState({
                        loading: false,
                        options: this._formatOptions(resp.body)
                    });
                }
            });
    }

    render() {
        if (this.state.loading) {
            return <div className={this.props.className}>Loading...</div>;
        } else {
            return <Select options={this.state.options} {...this.props} />;
        }
    }

    _formatOptions(response) {
        let out = [];

        Object.keys(response).map(key => {
            let formatted_option = {};
            formatted_option.id = key;
            formatted_option.label = response[key];

            out.push(formatted_option);
        });

        return out;
    }
}

export default StatusSelect;
